import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import Cookies from 'cookies-js';
export var PROFILE_ID_IN_SESSION = 'profileIdInSession';
var validateCookieDomainConfig = function validateCookieDomainConfig() {
  var COOKIE_DOMAIN = process.env.COOKIE_DOMAIN;
  if (!COOKIE_DOMAIN) {
    throw new Error("Invalid cookie domain setup COOKIE_DOMAIN: ".concat(COOKIE_DOMAIN));
  }
  return COOKIE_DOMAIN;
};
var getConfig = function getConfig(cookieDomain) {
  return {
    tokenKey: PROFILE_ID_IN_SESSION,
    referrerKey: 'referrerCode',
    expires: 365 * 24 * 3600,
    path: '/',
    domain: cookieDomain
  };
};
var setCookie = function setCookie(id) {
  var cookieDomain = validateCookieDomainConfig();
  if (id) {
    Cookies.set(PROFILE_ID_IN_SESSION, id, getConfig(cookieDomain));
  }
};
var getProfileIdCookie = function getProfileIdCookie() {
  return Cookies.get(PROFILE_ID_IN_SESSION) || null;
};
var get = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestProfileId, token) {
    var cookieValue, requestedProfileId;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          console.log('currentProfileIdService get :: STARTED');
          cookieValue = getProfileIdCookie();
          if (!cookieValue) {
            _context.next = 5;
            break;
          }
          console.log('currentProfileIdService get :: DONE :: profileId found as cookie', cookieValue);
          return _context.abrupt("return", cookieValue);
        case 5:
          _context.next = 7;
          return requestProfileId(token);
        case 7:
          requestedProfileId = _context.sent;
          if (!requestProfileId) {
            console.error('currentProfileIdService get :: ERROR :: requestProfileId did not return a profileId');
          }
          setCookie(requestedProfileId);
          console.log('currentProfileIdService get :: DONE :: requestProfileId returned a profileId', requestedProfileId);
          return _context.abrupt("return", requestedProfileId);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function get(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var reset = function reset() {
  if (!getProfileIdCookie()) {
    console.warn("".concat(PROFILE_ID_IN_SESSION, " key not found in Browser Cookies"));
    return '';
  }
  document.cookie = "".concat(PROFILE_ID_IN_SESSION, "= ; expires = Thu, 28 Sept 1984 00:00:00 GMT; path=/; domain=").concat(validateCookieDomainConfig(), ";");
  return "".concat(PROFILE_ID_IN_SESSION, " Cookie has been deleted from Browser Cookies");
};
export var currentProfileIdService = {
  get: get,
  reset: reset,
  getProfileIdCookie: getProfileIdCookie,
  setCookie: setCookie
};